import { Text, Tooltip } from "@mantine/core";
import { formatRelative, formatTimestamp } from "@/lib/datetime";

/**
 * Shows relative time with the absolute UTC timestamp on hover (ops want both:
 * "3m ago" for scanning, exact UTC for correlating with logs).
 */
export function Timestamp({
  value,
  absolute = false,
}: {
  value: string | null | undefined;
  absolute?: boolean;
}) {
  if (!value) return <Text span c="dimmed">—</Text>;
  if (absolute) {
    return (
      <Tooltip label={formatRelative(value)} withArrow>
        <Text span size="sm" ff="monospace">
          {formatTimestamp(value)}
        </Text>
      </Tooltip>
    );
  }
  return (
    <Tooltip label={formatTimestamp(value)} withArrow>
      <Text span size="sm">
        {formatRelative(value)}
      </Text>
    </Tooltip>
  );
}
